import { useEffect, useState } from 'react';
import { useDrawer } from '../../../shared/drawer';
import { PageBody } from '../../../elements/page-body';
import { Table } from '../../../elements/table';
import { ProviderForm } from './provider-form';


export const Providers = () => {
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);


    const handleNewAction = () => {
        open('common.form-title.new', <ProviderForm close={handleClose} />);
    };


    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };


    return (
        <PageBody
            newAction={handleNewAction}
            title={'common.form-label.proveedores-vehicle'}
            newActionTitle={'common.form-title.new'}

        >
            <>

                <Table
                    path="/fleet/vehicle-providers/"
                    deletePath="/fleet/vehicle-providers/"
                    callBeforeDrawerClosed={handleClose}
                    Form={ProviderForm}
                    withPagination
                    refresh={refresh}
                    headers={[

                        {
                            key: 'code',
                            label: 'common.label.codigo'
                        },                        
                        {
                            key: 'name',
                            label: 'common.form-label.name'
                        },
                    ]}
                />
            </>
        </PageBody>
    );
};
